import { render } from "./ChatRetratil.vue?vue&type=template&id=565060d8"
const script = {}
script.render = render

export default script